import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { showAddVehicleDialog, hideAddVehicleDialog } from '../store/actions/vehicleDialog.actions';

export const useVehicleDialog = () => {
  const dispatch = useDispatch();
  const savedResult = useSelector((state) => state.vehicleDialog.savedResult);
  const pendingRequest = useRef(null);

  useEffect(() => {
    const request = pendingRequest.current;
    if (request && savedResult?.requestId === request.requestId)
      request.onVehicleCreated?.(savedResult.vehicle);
  }, [savedResult]);

  const openVehicleDialog = useCallback(
    (options = {}) => {
      const requestId = uuid();
      pendingRequest.current = { ...options, requestId };
      dispatch(showAddVehicleDialog({ requestId, closeOnSave: options.closeOnSave }));
    },
    [dispatch]
  );

  const closeVehicleDialog = useCallback((requestId) => dispatch(hideAddVehicleDialog(requestId)), [
    dispatch,
  ]);

  return { openVehicleDialog, closeVehicleDialog };
};
